<div class="token-validation">
  <h2>Validação de Token</h2>
  <p>Insira o código de 4 dígitos que foi enviado por SMS para o celular cadastrado.</p>
  <div class="token-input-container">
    <input 
      type="text"
      maxlength="4" 
      [(ngModel)]="attribute.value"
      placeholder="XXXX">
  </div>
  <p class="resend-text">
    Não recebeu seu código? <a href="javascript:;" (click)="onTokenResend()">Reenviar token</a>
  </p>
</div>
